export interface CurriculumWeek {
  week: string;
  title: string;
  description: string;
  topics: string[];
}

export const curriculum: CurriculumWeek[] = [
  {
    week: '0–15 min',
    title: 'The New Age of AI',
    description: 'Understand why now is the most important moment to learn AI — and what separates builders from bystanders.',
    topics: [
      'What\'s actually changed with modern AI tools',
      'Why most people get AI wrong',
      'The builder mindset vs the consumer mindset',
      'What you can realistically build in 2026',
    ],
  },
  {
    week: '15–40 min',
    title: 'Frameworks for Building with AI',
    description: 'The mental models and systems that let you use AI to build anything — fast.',
    topics: [
      'How to think about AI as a collaborator, not a tool',
      'The TRUST Loop: a repeatable framework for AI execution',
      'Identifying your highest-leverage use-cases',
      'Prompt design principles that actually work',
    ],
  },
  {
    week: '40–70 min',
    title: 'How Builders Think',
    description: 'Real examples of how products and ideas have been built with AI in 2026.',
    topics: [
      'How to break down any idea into AI-ready steps',
      'Picking the right AI tools for the job',
      'Common mistakes and how to avoid them',
      'What separates builders who ship from those who stay stuck',
    ],
  },
  {
    week: '70–90 min',
    title: 'Your Next Steps',
    description: 'Leave with a clear action plan tailored to what you want to build.',
    topics: [
      'Mapping your idea to the right AI stack',
      'What to build first (and what to skip)',
      'Resources and communities to keep growing',
      'Open Q&A',
    ],
  },
];
